module.exports = __webpack_public_path__ + "img/9788958282402.ff634315.jpg";